import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SupplierPriceImportWorkspaceFragment = { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null };

export type GetSupplierPriceImportQueryVariables = Types.Exact<{
  importId: Types.Scalars['String']['input'];
}>;


export type GetSupplierPriceImportQuery = { __typename?: 'Query', supplierPriceImport?: { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null } | null };

export type SupplierPriceImportRowFragment = { __typename?: 'SupplierPriceImportRowDocument', baseOnlyIntent: boolean, disposition: Types.SupplierPriceRowDisposition, draftCategory: string, draftName: string, droppedInSource: boolean, effectiveDateDeliberatelyOmitted: boolean, extractedBasePerEachText?: string | null, extractedBasePerEachUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedConfirmedQuantityText?: string | null, extractedConfirmedQuantityUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedCurrency: string, extractedDescription: string, extractedEffectiveDate?: Types.TDateISO | null, extractedExtensionText?: string | null, extractedExtensionUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedForm?: string | null, extractedItemCode: string, extractedNotes: string, extractedOrderedQuantityText?: string | null, extractedOrderedQuantityUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedQuotedUnitText?: string | null, extractedRoyaltyPerEachText?: string | null, extractedRoyaltyPerEachUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedSize?: string | null, manufacturerAmbiguous: boolean, reviewNotes: string, reviewedBaseBasis: Types.SupplierPriceQuoteBasis, reviewedBaseDenominator: number, reviewedBasePerEachText?: string | null, reviewedEffectiveDate?: Types.TDateISO | null, reviewedManufacturerLabel: string, reviewedManufacturerVendorId: string, reviewedRoyaltyBasis: Types.SupplierPriceQuoteBasis, reviewedRoyaltyDenominator: number, reviewedRoyaltyPerEachText?: string | null, rowRevision: number, royaltyReviewState: Types.SupplierPriceImportRoyaltyReviewState, selected: boolean, sharedDraftId: string, sourceOrdinal: number, sourcePage: number, sourceRowId: string, targetMaterialItemId: string };

export type GetSupplierPriceImportRowsQueryVariables = Types.Exact<{
  importId: Types.Scalars['String']['input'];
}>;


export type GetSupplierPriceImportRowsQuery = { __typename?: 'Query', supplierPriceImportRows: Array<{ __typename?: 'SupplierPriceImportRowDocument', baseOnlyIntent: boolean, disposition: Types.SupplierPriceRowDisposition, draftCategory: string, draftName: string, droppedInSource: boolean, effectiveDateDeliberatelyOmitted: boolean, extractedBasePerEachText?: string | null, extractedBasePerEachUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedConfirmedQuantityText?: string | null, extractedConfirmedQuantityUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedCurrency: string, extractedDescription: string, extractedEffectiveDate?: Types.TDateISO | null, extractedExtensionText?: string | null, extractedExtensionUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedForm?: string | null, extractedItemCode: string, extractedNotes: string, extractedOrderedQuantityText?: string | null, extractedOrderedQuantityUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedQuotedUnitText?: string | null, extractedRoyaltyPerEachText?: string | null, extractedRoyaltyPerEachUnresolvedReason?: Types.SupplierPriceAmountUnresolvedReason | null, extractedSize?: string | null, manufacturerAmbiguous: boolean, reviewNotes: string, reviewedBaseBasis: Types.SupplierPriceQuoteBasis, reviewedBaseDenominator: number, reviewedBasePerEachText?: string | null, reviewedEffectiveDate?: Types.TDateISO | null, reviewedManufacturerLabel: string, reviewedManufacturerVendorId: string, reviewedRoyaltyBasis: Types.SupplierPriceQuoteBasis, reviewedRoyaltyDenominator: number, reviewedRoyaltyPerEachText?: string | null, rowRevision: number, royaltyReviewState: Types.SupplierPriceImportRoyaltyReviewState, selected: boolean, sharedDraftId: string, sourceOrdinal: number, sourcePage: number, sourceRowId: string, targetMaterialItemId: string }> };

export type GetSupplierPriceImportRowCandidatesQueryVariables = Types.Exact<{
  importId: Types.Scalars['String']['input'];
  sourceRowId: Types.Scalars['String']['input'];
}>;


export type GetSupplierPriceImportRowCandidatesQuery = { __typename?: 'Query', supplierPriceImportRowCandidates: { __typename?: 'SupplierPriceCandidateResult', sourceRowId: string, truncated: boolean, candidates: Array<{ __typename?: 'SupplierPriceMaterialCandidate', category: string, description: string, isAvailable: boolean, isDefaultVendor: boolean, matchKind: Types.SupplierPriceCandidateMatchKind, materialItemId: string, name: string, rank: number, vendorItemId: string }> } };

export type GetSupplierPriceImportHeldRowsQueryVariables = Types.Exact<{
  importId: Types.Scalars['String']['input'];
}>;


export type GetSupplierPriceImportHeldRowsQuery = { __typename?: 'Query', supplierPriceImportHeldRows: Array<{ __typename?: 'SupplierPriceBlockedRow', blockers: Array<Types.SupplierPriceReviewBlocker>, sourceOrdinal: number, sourcePage: number, sourceRowId: string }> };

export type GetSupplierPriceImportsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSupplierPriceImportsQuery = { __typename?: 'Query', supplierPriceImports: Array<{ __typename?: 'SupplierPriceImportDocument', activeApprovalId: string, updatedAt: Types.TDateISO, attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null }> };

export type SupplierPriceImportApplyFragment = { __typename?: 'SupplierPriceImportApply', approvalState: Types.SupplierPriceImportApprovalState, stepsRemain: boolean, rows: Array<{ __typename?: 'SupplierPriceImportApplyRow', changesCurrentCosting?: boolean | null, createdMaterial: boolean, disposition: Types.SupplierPriceRowDisposition, knownSubtotalPerEach?: string | null, materialItemId?: string | null, royaltyStatus?: Types.SupplierRoyaltyStatus | null, sourceRowId: string, status: Types.SupplierPriceImportApplyRowStatus, write?: Types.MaterialPriceOperationKind | null }>, stop?: { __typename?: 'SupplierPriceImportApplyStop', message: string, result: Types.SupplierPriceImportApplyStepResult, sourceRowIds: Array<string> } | null };

export type GetSupplierPriceImportApplyQueryVariables = Types.Exact<{
  importId: Types.Scalars['String']['input'];
  approvalId: Types.Scalars['String']['input'];
}>;


export type GetSupplierPriceImportApplyQuery = { __typename?: 'Query', supplierPriceImportApply?: { __typename?: 'SupplierPriceImportApply', approvalState: Types.SupplierPriceImportApprovalState, stepsRemain: boolean, rows: Array<{ __typename?: 'SupplierPriceImportApplyRow', changesCurrentCosting?: boolean | null, createdMaterial: boolean, disposition: Types.SupplierPriceRowDisposition, knownSubtotalPerEach?: string | null, materialItemId?: string | null, royaltyStatus?: Types.SupplierRoyaltyStatus | null, sourceRowId: string, status: Types.SupplierPriceImportApplyRowStatus, write?: Types.MaterialPriceOperationKind | null }>, stop?: { __typename?: 'SupplierPriceImportApplyStop', message: string, result: Types.SupplierPriceImportApplyStepResult, sourceRowIds: Array<string> } | null } | null };

export const SupplierPriceImportWorkspaceFragmentDoc = new TypedDocumentString(`
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}
    `, {"fragmentName":"SupplierPriceImportWorkspace"});
export const SupplierPriceImportRowFragmentDoc = new TypedDocumentString(`
    fragment SupplierPriceImportRow on SupplierPriceImportRowDocument {
  baseOnlyIntent
  disposition
  draftCategory
  draftName
  droppedInSource
  effectiveDateDeliberatelyOmitted
  extractedBasePerEachText
  extractedBasePerEachUnresolvedReason
  extractedConfirmedQuantityText
  extractedConfirmedQuantityUnresolvedReason
  extractedCurrency
  extractedDescription
  extractedEffectiveDate
  extractedExtensionText
  extractedExtensionUnresolvedReason
  extractedForm
  extractedItemCode
  extractedNotes
  extractedOrderedQuantityText
  extractedOrderedQuantityUnresolvedReason
  extractedQuotedUnitText
  extractedRoyaltyPerEachText
  extractedRoyaltyPerEachUnresolvedReason
  extractedSize
  manufacturerAmbiguous
  reviewNotes
  reviewedBaseBasis
  reviewedBaseDenominator
  reviewedBasePerEachText
  reviewedEffectiveDate
  reviewedManufacturerLabel
  reviewedManufacturerVendorId
  reviewedRoyaltyBasis
  reviewedRoyaltyDenominator
  reviewedRoyaltyPerEachText
  rowRevision
  royaltyReviewState
  selected
  sharedDraftId
  sourceOrdinal
  sourcePage
  sourceRowId
  targetMaterialItemId
}
    `, {"fragmentName":"SupplierPriceImportRow"});
export const SupplierPriceImportApplyFragmentDoc = new TypedDocumentString(`
    fragment SupplierPriceImportApply on SupplierPriceImportApply {
  approvalState
  rows {
    changesCurrentCosting
    createdMaterial
    disposition
    knownSubtotalPerEach
    materialItemId
    royaltyStatus
    sourceRowId
    status
    write
  }
  stepsRemain
  stop {
    message
    result
    sourceRowIds
  }
}
    `, {"fragmentName":"SupplierPriceImportApply"});
export const GetSupplierPriceImportDocument = new TypedDocumentString(`
    query GetSupplierPriceImport($importId: String!) {
  supplierPriceImport(importId: $importId) {
    ...SupplierPriceImportWorkspace
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const GetSupplierPriceImportRowsDocument = new TypedDocumentString(`
    query GetSupplierPriceImportRows($importId: String!) {
  supplierPriceImportRows(importId: $importId) {
    ...SupplierPriceImportRow
  }
}
    fragment SupplierPriceImportRow on SupplierPriceImportRowDocument {
  baseOnlyIntent
  disposition
  draftCategory
  draftName
  droppedInSource
  effectiveDateDeliberatelyOmitted
  extractedBasePerEachText
  extractedBasePerEachUnresolvedReason
  extractedConfirmedQuantityText
  extractedConfirmedQuantityUnresolvedReason
  extractedCurrency
  extractedDescription
  extractedEffectiveDate
  extractedExtensionText
  extractedExtensionUnresolvedReason
  extractedForm
  extractedItemCode
  extractedNotes
  extractedOrderedQuantityText
  extractedOrderedQuantityUnresolvedReason
  extractedQuotedUnitText
  extractedRoyaltyPerEachText
  extractedRoyaltyPerEachUnresolvedReason
  extractedSize
  manufacturerAmbiguous
  reviewNotes
  reviewedBaseBasis
  reviewedBaseDenominator
  reviewedBasePerEachText
  reviewedEffectiveDate
  reviewedManufacturerLabel
  reviewedManufacturerVendorId
  reviewedRoyaltyBasis
  reviewedRoyaltyDenominator
  reviewedRoyaltyPerEachText
  rowRevision
  royaltyReviewState
  selected
  sharedDraftId
  sourceOrdinal
  sourcePage
  sourceRowId
  targetMaterialItemId
}`);
export const GetSupplierPriceImportRowCandidatesDocument = new TypedDocumentString(`
    query GetSupplierPriceImportRowCandidates($importId: String!, $sourceRowId: String!) {
  supplierPriceImportRowCandidates(importId: $importId, sourceRowId: $sourceRowId) {
    candidates {
      category
      description
      isAvailable
      isDefaultVendor
      matchKind
      materialItemId
      name
      rank
      vendorItemId
    }
    sourceRowId
    truncated
  }
}
    `);
export const GetSupplierPriceImportHeldRowsDocument = new TypedDocumentString(`
    query GetSupplierPriceImportHeldRows($importId: String!) {
  supplierPriceImportHeldRows(importId: $importId) {
    blockers
    sourceOrdinal
    sourcePage
    sourceRowId
  }
}
    `);
export const GetSupplierPriceImportsDocument = new TypedDocumentString(`
    query GetSupplierPriceImports {
  supplierPriceImports {
    ...SupplierPriceImportWorkspace
    activeApprovalId
    updatedAt
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const GetSupplierPriceImportApplyDocument = new TypedDocumentString(`
    query GetSupplierPriceImportApply($importId: String!, $approvalId: String!) {
  supplierPriceImportApply(importId: $importId, approvalId: $approvalId) {
    ...SupplierPriceImportApply
  }
}
    fragment SupplierPriceImportApply on SupplierPriceImportApply {
  approvalState
  rows {
    changesCurrentCosting
    createdMaterial
    disposition
    knownSubtotalPerEach
    materialItemId
    royaltyStatus
    sourceRowId
    status
    write
  }
  stepsRemain
  stop {
    message
    result
    sourceRowIds
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetSupplierPriceImport: build.query<GetSupplierPriceImportQuery, GetSupplierPriceImportQueryVariables>({
      query: (variables) => ({ document: GetSupplierPriceImportDocument, variables })
    }),
    GetSupplierPriceImportRows: build.query<GetSupplierPriceImportRowsQuery, GetSupplierPriceImportRowsQueryVariables>({
      query: (variables) => ({ document: GetSupplierPriceImportRowsDocument, variables })
    }),
    GetSupplierPriceImportRowCandidates: build.query<GetSupplierPriceImportRowCandidatesQuery, GetSupplierPriceImportRowCandidatesQueryVariables>({
      query: (variables) => ({ document: GetSupplierPriceImportRowCandidatesDocument, variables })
    }),
    GetSupplierPriceImportHeldRows: build.query<GetSupplierPriceImportHeldRowsQuery, GetSupplierPriceImportHeldRowsQueryVariables>({
      query: (variables) => ({ document: GetSupplierPriceImportHeldRowsDocument, variables })
    }),
    GetSupplierPriceImports: build.query<GetSupplierPriceImportsQuery, GetSupplierPriceImportsQueryVariables | void>({
      query: (variables) => ({ document: GetSupplierPriceImportsDocument, variables })
    }),
    GetSupplierPriceImportApply: build.query<GetSupplierPriceImportApplyQuery, GetSupplierPriceImportApplyQueryVariables>({
      query: (variables) => ({ document: GetSupplierPriceImportApplyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetSupplierPriceImportQuery, useLazyGetSupplierPriceImportQuery, useGetSupplierPriceImportRowsQuery, useLazyGetSupplierPriceImportRowsQuery, useGetSupplierPriceImportRowCandidatesQuery, useLazyGetSupplierPriceImportRowCandidatesQuery, useGetSupplierPriceImportHeldRowsQuery, useLazyGetSupplierPriceImportHeldRowsQuery, useGetSupplierPriceImportsQuery, useLazyGetSupplierPriceImportsQuery, useGetSupplierPriceImportApplyQuery, useLazyGetSupplierPriceImportApplyQuery } = injectedRtkApi;
